import React, { useState } from 'react';
import './Register.css';
import { Link, useNavigate } from "react-router-dom";


import hayatlogo from '../assets/images/hayatlogo.jpg';
import hayatin from '../assets/images/hayatin.jpg'
import mobileicon from '../assets/images/mobileicon.jpg'
import nameicon from '../assets/images/nameicon.jpg'
import emailicon from '../assets/images/emailicon.jpg'
import passwordicon from '../assets/images/passwordicon.jpg'
import passwordshowicon from '../assets/images/passwordshowicon.jpg'
import google from '../assets/images/google.jpg'
import facebook from '../assets/images/facebook.jpg'
import ios from '../assets/images/ios.jpg'
import axios from 'axios';
import { BACKEND_URL } from './common/Common';


const Register = () => {
    const navigate = useNavigate();
    const navigatetoprivacypolicy = () => {
        navigate("/privacypolicy");
    };
    const [showPassword, setShowPassword] = useState(false);
    const togglePassword = () => setShowPassword(!showPassword);

    // Form state
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        password: "",
        agreeToTerms: false
    });

    // Validation errors
    const [errors, setErrors] = useState({
        name: "",
        email: "",
        mobile: "",
        password: "",
        agreeToTerms: ""
    });

    const [resgistersendotp, setRegisterSendOtp] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Handle input changes
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        // For mobile field, only allow digits and limit to 9 digits
        let processedValue = value;
        if (name === 'mobile') {
            // Remove any non-digit characters
            processedValue = value.replace(/\D/g, '');
            // Limit to 9 digits
            if (processedValue.length > 9) {
                processedValue = processedValue.slice(0, 9);
            }
        }

        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : processedValue
        }));
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ""
            }));
        }
    };

    // Validation functions
    const validateName = (name) => {
        if (!name.trim()) {
            return "Name is required";
        }
        if (name.trim().length < 2) {
            return "Name must be at least 2 characters";
        }
        return "";
    };

    const validateEmail = (email) => {
        if (!email.trim()) {
            return "Email is required";
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            return "Please enter a valid email address";
        }
        return "";
    };

    const validateMobile = (mobile) => {
        const mobileNumber = mobile.trim();

        if (!mobileNumber) {
            return "Please enter mobile number";
        }

        if (mobileNumber.startsWith("0")) {
            return "Enter your 9-digit mobile number without the leading zero";
        }

        if (mobileNumber.length !== 9) {
            return "Please Enter your 9 Digit mobile Number";
        }

        return "";
    };

    const validatePassword = (password) => {
        if (!password) {
            return "Password is required";
        }
        if (password.length < 6) {
            return "Password must be at least 6 characters";
        }
        return "";
    };

    const validateCheckbox = (checked) => {
        if (!checked) {
            return "You must agree to the Privacy Policy and Terms of Use";
        }
        return "";
    };

    // Validate all fields
    const validateForm = () => {
        const newErrors = {
            name: validateName(formData.name),
            email: validateEmail(formData.email),
            mobile: validateMobile(formData.mobile),
            password: validatePassword(formData.password),
            agreeToTerms: validateCheckbox(formData.agreeToTerms)
        };

        setErrors(newErrors);

        // Check if there are any errors
        return !Object.values(newErrors).some(error => error !== "");
    };

    const fetchregistersendotp = async (mobile, email) => {
        const payload = {
            mobile: mobile,
            email: email,
        }
        console.log("Register Send OTP Payload:", payload);
        try {
            const response = await axios.post(`${BACKEND_URL}website/register-send-otp`, payload);
            // const response = await axios.post(`http://localhost:8000/api/website/register-send-otp`,payload);
            console.log("Register Send OTP Response:", response.data);

            // Check if response has status "0" (error condition even with 200 status)
            if (response.data && (response.data.status === "0" || response.data.status === 0)) {
                const responseMessage = response.data.message || "";
                let emailError = "";
                let mobileError = "";
                let errorMessage = responseMessage || "Failed to send OTP. Please try again.";

                // Check if message indicates email already registered
                const messageLower = responseMessage.toLowerCase();
                if (messageLower.includes('email') && (messageLower.includes('already') || messageLower.includes('registered'))) {
                    emailError = responseMessage || "This Email Address Has been Already Registered";
                }

                // Check if message indicates mobile already registered (and NOT email)
                if (!messageLower.includes('email') &&
                    (messageLower.includes('mobile') || messageLower.includes('number')) &&
                    (messageLower.includes('already') || messageLower.includes('registered'))) {
                    mobileError = responseMessage || "This Mobile Number Has been Already Registered";
                }

                return {
                    success: false,
                    error: errorMessage,
                    emailError: emailError,
                    mobileError: mobileError
                };
            }

            // Success case - status is not "0"
            setRegisterSendOtp(response.data);
            return { success: true, error: null };
        } catch (error) {
            console.log("Error Fetching Register Send Otp", error);

            // Extract error message from API response
            let errorMessage = "Failed to send OTP. Please try again.";
            let emailError = "";
            let mobileError = "";

            if (error.response && error.response.data) {
                const errorData = error.response.data;
                errorMessage = errorData.message || errorData.error || errorMessage;

                // Check for duplicate email or mobile errors
                const errorString = JSON.stringify(errorData).toLowerCase();

                if (errorString.includes('email') && (errorString.includes('already') || errorString.includes('exist') || errorString.includes('duplicate'))) {
                    emailError = "This email is already registered. Please use a different email or sign in.";
                }

                if (errorString.includes('mobile') && (errorString.includes('already') || errorString.includes('exist') || errorString.includes('duplicate'))) {
                    mobileError = "This mobile number is already registered. Please use a different number or sign in.";
                }
            }

            return {
                success: false,
                error: errorMessage,
                emailError: emailError,
                mobileError: mobileError
            };
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Prevent double submission
        if (isSubmitting) {
            return;
        }
        // Validate all fields
        if (!validateForm()) {
            return;
        }

        // Set submitting state to prevent double clicks
        setIsSubmitting(true);

        // Store name, password, mobile, and email in localStorage
        localStorage.setItem('registerName', formData.name);
        localStorage.setItem('registerPassword', formData.password);
        localStorage.setItem('registerMobile', formData.mobile);
        localStorage.setItem('registerEmail', formData.email);

        // Log registration data being stored
        console.log("Registration Data Stored in localStorage:", {
            name: formData.name,
            email: formData.email,
            mobile: formData.mobile,
            password: "***" // Don't log password
        });

        try {
            // Call API with mobile (with country code) and email
            const mobileWithCountryCode = `+971${formData.mobile}`;
            const result = await fetchregistersendotp(mobileWithCountryCode, formData.email);

            if (result.success) {
                // Navigate to OTP page immediately after successful API call
                navigate("/otp");
            } else {
                // Handle errors - show specific error messages for duplicate email/mobile
                const newErrors = { ...errors };

                if (result.emailError) {
                    newErrors.email = result.emailError;
                }

                if (result.mobileError) {
                    newErrors.mobile = result.mobileError;
                }

                setErrors(newErrors);

                // If no specific field errors, show general error
                if (!result.emailError && !result.mobileError) {
                    alert(result.error || "Failed to send OTP. Please try again.");
                }

                // Clear localStorage on error to prevent navigation issues
                localStorage.removeItem('registerMobile');
                localStorage.removeItem('registerEmail');
                localStorage.removeItem('registerName');
                localStorage.removeItem('registerPassword');

                // Reset submitting state on error
                setIsSubmitting(false);
            }
        } catch (error) {
            // Handle unexpected errors
            console.error("Unexpected error during registration:", error);
            alert("An unexpected error occurred. Please try again.");
            setIsSubmitting(false);

            // Clear localStorage on error
            localStorage.removeItem('registerMobile');
            localStorage.removeItem('registerEmail');
            localStorage.removeItem('registerName');
            localStorage.removeItem('registerPassword');
        }
    };

    return (
        <div className="register-container">
            <div className="register-left">
                <img src={hayatlogo} alt="Register" />
            </div>

            <div className='register-right'>
                <div className='rightside-header'>
                    <img src={hayatin} alt='hayatin' />
                    <div className='signin-account'>
                        <p>Already have an account?</p>
                        <Link to="/login" className="signin-link">
                            Sign In
                        </Link>
                    </div>
                </div>

                <div className='center-banner'>
                    <div className='register-heading'>
                        <h4>Start Your Hayat In Journey</h4>
                    </div>

                    <div className='form-container'>

                        <form onSubmit={handleSubmit}>
                            <div className="input-group">
                                <h6>Name <span>*</span></h6>
                                <div className='input-field'>
                                    <img src={nameicon} alt='nameicon' className="input-icon" />
                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                        placeholder="Enter Your Name"
                                    />
                                </div>
                                {errors.name && <span style={{ color: 'red', fontSize: '12px', marginTop: '5px', display: 'block' }}>{errors.name}</span>}
                            </div>
                            <div className="input-group">
                                <h6>Email <span>*</span></h6>
                                <div className='input-field'>
                                    <img src={emailicon} alt='emailicon' className="input-icon" />
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        placeholder="Enter Your Email"
                                    />
                                </div>
                                {errors.email && <span style={{ color: 'red', fontSize: '12px', marginTop: '5px', display: 'block' }}>{errors.email}</span>}
                            </div>
                            <div className="input-group">
                                <h6>Mobile No <span>*</span></h6>
                                <div className='input-field mobile-input-field'>
                                    <img src={mobileicon} alt='mobileicon' className="input-icon" />
                                    <span className="country-code">+971</span>
                                    <input
                                        type="tel"
                                        name="mobile"
                                        value={formData.mobile}
                                        onChange={handleInputChange}
                                        placeholder="Enter Your Mobile Number"
                                        maxLength={9}
                                    />
                                </div>
                                {errors.mobile && <span style={{ color: 'red', fontSize: '12px', marginTop: '5px', display: 'block' }}>{errors.mobile}</span>}
                            </div>
                            <div className="input-group">
                                <h6>Password <span>*</span></h6>
                                <div className='input-field'>
                                    <img src={passwordicon} alt='passwordicon' className="input-icon" />
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        name="password"
                                        value={formData.password}
                                        onChange={handleInputChange}
                                        placeholder="Enter Your Password"
                                    />
                                    <img
                                        src={passwordshowicon}
                                        alt='passwordshowicon'
                                        className="passwordshow-icon"
                                        onClick={togglePassword}
                                        style={{ cursor: "pointer" }}
                                    />
                                </div>
                                {errors.password && <span style={{ color: 'red', fontSize: '12px', marginTop: '5px', display: 'block' }}>{errors.password}</span>}
                            </div>

                            <div className='policy-terms'>
                                <input
                                    type="checkbox"
                                    name="agreeToTerms"
                                    checked={formData.agreeToTerms}
                                    onChange={handleInputChange}
                                />
                                <h6>
                                    I agree with{" "}
                                    <span onClick={navigatetoprivacypolicy} style={{cursor:"pointer"}}>Privacy Policy</span> and{" "}
                                    <span>Terms of Use</span>
                                </h6>
                            </div>
                            {errors.agreeToTerms && <span style={{ color: 'red', fontSize: '12px', marginTop: '5px', display: 'block', position: 'relative', left: '35px', bottom: '10px' }}>{errors.agreeToTerms}</span>}

                            <div className='createaccount-button'>
                                <button
                                    type="submit"
                                    className="create-account-btn"
                                    disabled={isSubmitting}
                                >
                                    Create Account
                                </button>
                            </div>

                        </form>
                        <div className="divider">
                            <hr /><p>Continue With</p><hr />
                        </div>
                        <div className='socialicon'>
                            <img src={google} alt='google' />
                            <img src={facebook} alt='facebook' />
                            <img src={ios} alt='ios' />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Register